import { Response, apiAbortController } from '@ui/src';
import api from '../../../api/api';
import { FeesValidators, FeeItem, FeeItemFormValues } from '../types';

export const feesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getFeesValidators: build.query<{ data: FeesValidators }, void>({
      query: () => ({
        url: '/v1/fees/validators',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getFeesList: build.query<Response<FeeItem>, void>({
      query: () => ({
        url: `/v1/fees?all=true`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getFeeItem: build.query<{ data: FeeItem }, string>({
      query: (id) => ({
        url: `/v1/fees/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    createFeeItem: build.mutation<
      {
        data: FeeItem;
      },
      FeeItemFormValues
    >({
      query: (body) => ({
        url: '/v1/fees',
        method: 'POST',
        body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    updateFeeItem: build.mutation<
      {
        data: FeeItem;
      },
      { body: FeeItemFormValues; id: string }
    >({
      query: (data) => ({
        url: `/v1/fees/${data.id}`,
        method: 'PUT',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getConfigurationTransactionTypes: build.query<
      Response<{ name: string; id: string }>,
      void
    >({
      query: () => ({
        url: '/v1/transactions-types?all=true',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetFeeItemQuery,
  useLazyGetFeesListQuery,
  useGetFeesValidatorsQuery,
  useLazyGetFeesValidatorsQuery,
  useCreateFeeItemMutation,
  useGetConfigurationTransactionTypesQuery,
  useUpdateFeeItemMutation,
} = feesApi;

export const {
  endpoints: {
    getFeeItem,
    getFeesList,
    getFeesValidators,
    createFeeItem,
    updateFeeItem,
    getConfigurationTransactionTypes,
  },
} = feesApi;
